import BaseCrudService from "./baseCrud.service";

export default class SSOService extends BaseCrudService {

    constructor() {
        super('SSO');
    }

    init(){
        return this.postRequest('Init')
    }

    callback(code, state){
        return this.postRequest('Callback', {code, state});
    }

    resolveMsal(authenticationResult) {
        return this.postRequest('ResolveMsal', { authenticationResult });
    }
}